import React, { useEffect, useRef } from "react";
import { CRow, CCol, CCard, CCardBody, CCardHeader } from "@coreui/react";
import { CChart } from "@coreui/react-chartjs";
import { CWidgetStatsA } from "@coreui/react";

const BieuDo = () => {
  const chartRef = useRef(null);

  useEffect(() => {
    const handleColorSchemeChange = () => {
      const chartInstance = chartRef.current;
      if (chartInstance) {
        chartInstance.update();
      }
    };
    document.documentElement.addEventListener(
      "ColorSchemeChange",
      handleColorSchemeChange
    );
    return () => {
      document.documentElement.removeEventListener(
        "ColorSchemeChange",
        handleColorSchemeChange
      );
    };
  }, []);

  const data = {
    labels: ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6"],
    datasets: [
      {
        label: "Số nhân viên mới",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        borderColor: "rgba(75, 192, 192, 1)",
        data: [10, 15, 8, 12, 20, 18],
        fill: true,
      },
      {
        label: "Số nhân viên nghỉ việc",
        backgroundColor: "rgba(255, 99, 132, 0.2)",
        borderColor: "rgba(255, 99, 132, 1)",
        data: [5, 7, 3, 6, 8, 5],
        fill: true,
      },
    ],
  };

  return (
    <CRow>
      <CCol md={8}>
        <CCard>
          <CCardHeader>Biểu đồ nhân sự</CCardHeader>
          <CCardBody>
            <CChart type="line" data={data} ref={chartRef} />
          </CCardBody>
        </CCard>
      </CCol>

      <CCol md={4}>
        <CWidgetStatsA
          className="mb-3"
          color="primary"
          value="150"
          title="Tổng số nhân viên"
        />
        <CWidgetStatsA
          className="mb-3"
          color="success"
          value="20"
          title="Nhân viên mới trong tháng"
        />
        <CWidgetStatsA
          className="mb-3"
          color="danger"
          value="5"
          title="Nhân viên nghỉ việc trong tháng"
        />
      </CCol>

      <CCol md={12}>
        <CCard className="mt-3">
          <CCardHeader>Chu kỳ lương</CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md={3}>
                <CWidgetStatsA
                  color="info"
                  value="$500,000"
                  title="Tổng chi phí lương"
                />
              </CCol>
              <CCol md={3}>
                <CWidgetStatsA
                  color="warning"
                  value="150"
                  title="Số lượng nhân sự"
                />
              </CCol>
              <CCol md={3}>
                <CWidgetStatsA
                  color="success"
                  value="$3,333"
                  title="Mức lương trung bình"
                />
              </CCol>
              <CCol md={3}>
                <CWidgetStatsA
                  color="danger"
                  value="10%"
                  title="Tỷ lệ tăng lương"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default BieuDo;
